export const ANALYZING="ANALYZING";
export const AI_INTERVIEW_CREATED="AI_INTERVIEW_CREATED";
export const AI_INTERVIEW_LINK_SENT="AI_INTERVIEW_LINK_SENT";
export const SCREENING_ERROR="SCREENING_ERROR";
export const SCREENING_COMPLETED="SCREENING_COMPLETED";
export const AI_INTERVIEW_IN_PROGRESS="AI_INTERVIEW_IN_PROGRESS";
export const AI_INTERVIEW_EVALUATED="AI_INTERVIEW_EVALUATED";
export const IN_PERSON_INTERVIEW_SCHEDULED="IN_PERSON_INTERVIEW_SCHEDULED";
export const CANDIDATE_REJECTED="CANDIDATE_REJECTED";
export const CANDIDATE_HIRED="CANDIDATE_HIRED";
export const SCREENING_QUALIFIED="SCREENING_QUALIFIED";
export const SCREENING_DISQUALIFIED="SCREENING_DISQUALIFIED";
export const CODING_INTERVIEW_SUBMITTED = "CODING_INTERVIEW_SUBMITTED";
